import { render } from "./DeModal.vue?vue&type=template&id=621aadf6"
import script from "./DeModal.vue?vue&type=script&lang=js"
export * from "./DeModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__